import React, { useState } from "react";

import SvgEdit02 from "@uui/Edit02";
import { DateTime } from "luxon";

import Typography from "@mui/material/Typography";

import {
  HeaderTimeText,
  VerticalDivider,
} from "@app/analytics/components/reports/styles";
import { formatStartAndEndTime } from "@app/common/utils";

import ConfirmationModal from "@rui/ConfirmationModal";
import DatePicker from "@rui/DatePicker/DatePicker";
import Stack, { Row } from "@rui/Stack";
import TimePicker from "@rui/TimePicker/TimePicker";

const DateAndTime = ({
  startTime,
  endTime,
  canEditReport,
  onEdit,
}: {
  startTime: DateTime;
  endTime?: DateTime;
  canEditReport: boolean;
  onEdit: (props: { startTime: DateTime }) => void;
}) => {
  const [editDateModalOpen, setEditDateModalOpen] = useState(false);
  const [start, setStart] = useState(startTime);
  const [date, setDate] = useState(startTime);

  const handleSaveEdits = () => {
    const mergedStartTime = date?.set({
      hour: start?.hour,
      minute: start?.minute,
    });

    onEdit({ startTime: mergedStartTime });
    setEditDateModalOpen(false);
  };

  return (
    <>
      <Row
        variant="left"
        spacing={1}
        onClick={canEditReport ? () => setEditDateModalOpen(true) : undefined}
        sx={{
          paddingX: 0.25,
          borderRadius: "4px",
          "&:hover": canEditReport
            ? {
                backgroundColor: "shades.ghost.400",
                cursor: "pointer",
                svg: {
                  display: "inline",
                  color: "shades.primary.500",
                },
              }
            : {},
        }}
      >
        <HeaderTimeText>
          {startTime.toLocaleString({
            weekday: "short",
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
        </HeaderTimeText>
        <VerticalDivider size="sm" />
        <HeaderTimeText>
          {formatStartAndEndTime(startTime, endTime)}
        </HeaderTimeText>
        <SvgEdit02
          sx={{
            display: "none",
            fontSize: "14px",
            marginLeft: 1,
          }}
        />
      </Row>
      <ConfirmationModal
        open={editDateModalOpen}
        title="Edit date & time"
        onClose={() => setEditDateModalOpen(false)}
        onConfirm={handleSaveEdits}
        onCancel={() => setEditDateModalOpen(false)}
        confirmProps={{
          label: "Save changes",
        }}
      >
        <Stack spacing={2}>
          <Stack variant="left" spacing={0.5}>
            <Typography variant="labelReg">Date</Typography>
            <DatePicker
              disableFuture
              value={date}
              onChange={(newValue) => setDate(newValue ?? startTime)}
            />
          </Stack>
          <Stack variant="left" spacing={0.5}>
            <Typography variant="labelReg">Time</Typography>
            <TimePicker
              value={start}
              onChange={(newValue) => setStart(newValue ?? startTime)}
            />
          </Stack>
        </Stack>
      </ConfirmationModal>
    </>
  );
};

export default DateAndTime;
